var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUserIconSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 11,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.508 5.755A2.877 2.877 0 1 1 5.507 0a2.877 2.877 0 0 1 0 5.756ZM5.508 6.939c-2.593 0-4.125.783-4.949 1.444-.493.39-.679 1.01-.481 1.578C.292 10.582.925 11 1.65 11h7.728c.719 0 1.351-.418 1.572-1.039.197-.568.006-1.189-.482-1.578-.835-.655-2.367-1.444-4.96-1.444Z",
  fill: "#00BAC6"
})));
export { SvgUserIconSm as ReactComponent };
export default __webpack_public_path__ + "b2e9895c35c40ba85bf5aa763b06579c.svg";